import { render, staticRenderFns } from "./JciYearEdit.vue?vue&type=template&id=6bc8f36b"
import script from "./JciYearEdit.vue?vue&type=script&lang=js"
export * from "./JciYearEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports